import React from 'react';
import {
  useGetCashDocumentsByInvoiceQuery,
  useLazyGetCashDocumentPdfQuery,
} from '../../CashDocuments/Service/extendedCashDocumentsApi';
import {
  mapCashDocumentToInvoiceLookup,
  type InvoiceCashDocumentLookup,
} from './cashDocumentsLookupMapper';

export const useGetInvoiceCashDocumentsByInvoiceLookupQuery = (invoiceId: number) => {
  const queryResult = useGetCashDocumentsByInvoiceQuery(invoiceId);

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((document) => mapCashDocumentToInvoiceLookup(document as any))
        .filter((document): document is InvoiceCashDocumentLookup => Boolean(document)),
    [queryResult.data]
  );

  return {
    ...queryResult,
    data,
  };
};

export const useLazyGetInvoiceCashDocumentPdfQuery = useLazyGetCashDocumentPdfQuery;
